import { Card, Frame, Page } from "@shopify/polaris";
import React from "react";
import AccountStatistics from "./Dashboard/accountStatistics";
import Main_Page from "../Component/Main_Page";

function Analytics() {
    return (
        <div>
            <Main_Page />
            <Page
                breadcrumbs={[{ content: "Dashboard", url: "/" }]}
                title="Analytics"
            >
                <Frame>
                    <Card>
                        <div style={{ marginTop: "6rem" }}>
                            <AccountStatistics />
                        </div>
                    </Card>
                </Frame>
            </Page>
        </div>
    );
}

export default Analytics;
